import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import type { IPickDelete } from "../../types";
import { useGetAllFaculties } from "../getAll";
import { useGetFaculty } from "../get";

import type { IFacultyImage } from "./routeType";

import { getApi } from "@/api/apiPath";
import { axiosClient, queryClient } from "@/api/clients";

const { getPath } = getApi("faculties.image.delete");

type IExtractedRouteType = IFacultyImage["facultyImageSingleDelete"];

export type IDeleteFacultyImage = IPickDelete<IExtractedRouteType>;

const deleteFacultyImage: MutationFunction<
  IDeleteFacultyImage["response"],
  IDeleteFacultyImage["variables"]
> = ({ facultyId }) => {
  return axiosClient.delete(getPath({ facultyId }));
};

export const useDeleteFacultyImage = createMutation({
  mutationFn: deleteFacultyImage,
  onSuccess: (_, { facultyId }) => {
    queryClient.invalidateQueries({ queryKey: useGetAllFaculties.getKey() });
    queryClient.invalidateQueries({
      queryKey: useGetFaculty.getKey({ facultyId }),
    });
  },
});
